module.exports = __webpack_public_path__ + "img/automobile_btn.9d1b9836.png";